<template lang="pug">

  v-container.pageGroupContainer(tag="section" fluid)

    //-
      -
      -
      VOLTAR + PLANO
      -
      -
      -

    v-row

      v-col(cols="12" sm="6").column
        sos-button(@buttonClick="goBackToGroupScales" size="medium" color="default" buttonLabel="Voltar para o grupo" buttonIcon="mdi-arrow-left" buttonIconSize="16").mr-auto.btnVoltar

      v-col(cols="12" sm="6" end v-if="whiteLabel === false").column
        sos-current-plan-badge

    .pageBody

      //-
        -
        -
        CABEÇALHO (IMAGEM DO GRUPO, INFORMAÇÕES DO GRUPO E BOTÕES [CONVIDAR E ETC])
        -
        -
        -

      .groupUserDutiesPageHeader

        //- template(v-if="group")

        .csCol.csCol--1

          .groupTitleArea

            .groupTitleImage

              .groupImage

                .groupUserImage(v-if="userLocalProfile && userLocalProfile.userImage" :style="{ backgroundImage: 'url(' + userLocalProfile.userImage + ')' }")
                .groupUserImage(v-else)

              sos-button(@buttonClick="openEditUserProfile" buttonLabel="EDITAR" size="small" buttonIcon="mdi-account-edit" buttonIconSize="20" color="success").sosButton--full

            .groupTitleText

              h2.blockTitle(v-if="loadingUserProfile === false")
                | {{ userLocalProfile.userName || 'Não informado' }}
              h2.blockTitle(v-else)
                | Carregando...

              .userProfileItem
                b
                  | Apelido:&nbsp;
                span(v-if="loadingUserProfile === false")
                  | {{ userLocalProfile.nickname || 'Não informado' }}
                span(v-else)
                  | Carregando...

              .userProfile.mt-3

                .userProfileItem
                  b
                    | CRM:&nbsp;
                  span(v-if="loadingUserProfile === false")
                    | {{ userLocalProfile.userCrm || 'Não informado' }}
                  span(v-else)
                    | Carregando...

                .userProfileItem
                  b
                    | CPF:&nbsp;
                  span(v-if="loadingUserProfile === false")
                    | {{ userLocalProfile.userCpf || 'Não informado' }}
                  span(v-else)
                    | Carregando...

                .userProfileItem
                  b
                    | CNPJ:&nbsp;
                  span(v-if="loadingUserProfile === false")
                    | {{ userLocalProfile.userCnpj || 'Não informado' }}
                  span(v-else)
                    | Carregando...

                .userProfileItem
                  b
                    | Telefone:&nbsp;
                  span(v-if="loadingUserProfile === false")
                    | {{ userLocalProfile.userPhone || 'Não informado' }}
                  span(v-else)
                    | Carregando...

                .userProfileItem
                  b
                    | Valor hora no grupo:&nbsp;
                  span(v-if="loadingUserProfile === false")
                    | {{ userLocalProfile.hourlyRate === 'R$ 0,00' ? 'Não informado' : userLocalProfile.hourlyRate }}
                  span(v-else)
                    | Carregando...

                .userProfileItem
                  b
                    | Dados bancários:&nbsp;
                  span(v-if="loadingUserProfile === false")
                    | {{ userLocalProfile.userPaymentProfile || 'Não informado' }}
                  span(v-else)
                    | Carregando...

        .csCol.csCol--2

          .groupTitleArea
            .groupTitleImage
              .groupImage
                .groupUserImage(:style="{ backgroundImage: 'url(' + (group && group.img ? group.img : groupplaceholder) + ')' }")

            .groupTitleText

              h2.blockTitle {{ group && group.nome ? group.nome : 'Carregando...' }}

              .userProfile.mt-5

                .sosField
                  sos-select(label="Escala" :items="selectScales" @sosSelectChanged="onSelectScale" :default="scaleID" :disabled="loadingDuties")

                .sosFieldGroup
                  .sosField.sosFieldColumn--1
                    sos-select(label="Mês" :items="selectMonths" @sosSelectChanged="selectedMonth" :default="currentMonth" :disabled="loadingDuties")
                  .sosField.sosFieldColumn--2
                    sos-select(label="Ano" :items="selectYears" @sosSelectChanged="selectedYear" :default="currentYear" :disabled="loadingDuties")

        .csCol.csCol--3

          sos-button(v-if="permissaoDetalhesPlantaoNovoPlantao" @buttonClick="openNewUserDutyModal()" buttonLabel="NOVO PLANTÃO" size="medium" buttonIcon="mdi-plus" buttonIconSize="20" color="success")
        //- TODO: VERIFICAR ESTILO NO MOBILE
        .col-xs-12
          .col-xs--3(style="display: flex; justify-content: end; ")
            sos-button(v-if="permissaoDetalhesPlantaoNovoPlantao" @buttonClick="openPassShiftsModal" buttonLabel="PASSAR PLANTÕES" size="medium" buttonIcon="mdi-arrow-right-thin" buttonIconSize="20" color="grupoAcaoTodosPlantoesCompartilhar").sosButton

      //-
        -
        -
        PRÓXIMOS PLANTÕES
        -
        -
        -

      .groupUserDutiesHeader

        .loadingScale
          | Próximos plantões

        .periodBalance(v-if="loadedDuties.length > 0" :class="{ 'positive-balance': totalPeriodBalance.includes('+'), 'negative-balance': totalPeriodBalance.includes('-') }")
            span.balanceLabel Banco de horas:
            span.balanceValue {{ totalPeriodBalance }}

      .groupUserDuties(:class="{ 'groupUserDuties--loading': loadedDuties.length > 0 && loadingDuties === true }")

        //- .groupUserDuties--loadingWrapper
          span Atualizando...

        //- .groupUserDutiesColumn--1

        //- .groupUserDutiesColumn--2

        .groupUserDutiesMonthWrapper

          //- .groupUserDutiesMonth--name
            | Agosto de 2022

          .groupUserDutiesMonth--duties(v-if="loadedDuties.length > 0")

            //-
              -
              - "CARTÃO" DO PLANTÃO
              -
              -

            template(v-for="duty in loadedDuties")
              v-tooltip(top color="rgba(0, 0, 139, 0.95)")
                template(v-slot:activator="{ on, attrs }")
                  .groupUserDutiesMonth--duty(
                    v-bind="attrs"
                    v-on="on"
                    :class="{ 'groupUserDutiesMonth--duty__finished': !!duty.duty.start_location === true && !!duty.duty.end_location === true, 'groupUserDutiesMonth--duty__started': !!duty.duty.start_location === true && !!duty.duty.end_location === false, 'groupUserDutiesMonth--duty__cancelled': duty.duty.status === 'cancelado' }"
                    @click.stop.prevent="openDuty(duty.duty)"
                  )

                    .dutyCard--passing(v-if="duty.isPassing")
                      | PASSANDO

                    .dutyCard--violation(
                      v-if="duty.duty._violations && duty.duty._violations.length"
                      :class="{ 'dutyCard--violation__block': duty.duty._violations.some(v => v.action === 'block') }"
                    )
                      i(aria-hidden="true" class="mdi mdi-alert-circle")

                    .groupUserDutiesMonth--dutyBody

                      .dutyLabel(v-if="!!duty.duty.start_location === true && !!duty.duty.end_location === true")
                        | ENCERRADO
                      .groupUserDutiesMonth--dutyInner1
                        .groupUserDutiesMonth--dutyWeekDay {{ duty.dutyWeekDayName }}
                        .groupUserDutiesMonth--dutyDay {{ duty.dutyDay }}
                      .groupUserDutiesMonth--dutyInner2
                        .groupUserDutiesMonth--dutyTime
                          span Início:
                          span {{ duty.dutyTime }}
                        .groupUserDutiesMonth--dutyTime
                          span Duração:
                          span {{ duty.dutyDuration }}
                      .groupUserDutiesMonth--dutyScaleName {{ duty.duty.nome }}
                    .groupUserDutiesMonth--dutyValue
                      | {{ duty.dutyValue }}

                span(style="vertical-align: middle")
                  i(aria-hidden="true" class="mdi mdi-information-outline" style="font-size: 18px; display: inline-block; vertical-align: middle;")
                  b(style="display: inline-block; vertical-align: middle;") &nbsp;Informações completas
                  b(style="display: block; vertical-align: middle;") &nbsp;Dia: {{ duty.dutyDay }} - {{ duty.dutyWeekDayName }}
                  b(style="display: block; vertical-align: middle;") &nbsp;Início: {{ duty.dutyTime }}
                  b(style="display: block; vertical-align: middle;") &nbsp;Duração: {{ duty.dutyDuration }}
                  b(style="display: block; vertical-align: middle;") &nbsp;Escala: {{ duty.duty.nome }}
                  b(style="display: block; vertical-align: middle;") &nbsp;Valor: {{ duty.dutyValue }}
                  b(v-if="duty.duty._violations && duty.duty._violations.length" style="display: block; vertical-align: middle; color: #ffd9d9;") &nbsp;⚠ {{ duty.duty._violations[0].message }}

          .groupUserDutiesMonth--duties(v-else-if="loadedDuties.length === 0 && loadingDuties === true")

            .loadingScale
              | Carregando plantões...

          .groupUserDutiesMonth--duties(v-else)

            .loadingScale(v-if="listeners.loadingGroupScales === 'no' && processedGroupScales.length === 0")
              | O grupo ainda não tem escalas
            .loadingScale(v-else-if="scaleID === 'all'" v-html="`O usuário não tem plantões em <span style=\"color: #228b22; font-weight: 500\">${currentMonthName} de ${currentYear}</span>`")
            .loadingScale(v-else v-html="`O usuário não tem plantões em <span style=\"color: #228b22; font-weight: 500\">${currentMonthName} de ${currentYear}</span> na escala <span style=\"color: #228b22; font-weight: 500\">${scaleName}</span>`")

    new-user-duty-modal(ref="newUserDutyModal")

    manager-user-modal(ref="userModal" @onUpdate="onUserUpdate")

    detalhes-do-plantao(ref="dutyModal" :groupUsers="groupUsers" v-if="groupUsers")

    pass-shifts-modal(ref="passShiftsModal" :groupUsers="groupUsers" v-if="groupUsers",
      :scaleID="scaleID",
      :groupID="group.groupID"
    )

</template>

<script>

  import { freeVersion, whiteLabel, DETALHES_PLANTAO_NOVO_PLANTAO, DETALHES_PLANTAO_VER } from '@/constants'

  import { isShiftExpired } from '@/functions'

  import { processUserCpf, processUserCnpj, formatFloatToScaleDuration, formatMoney, formatDbTime, durationToMinutes, getShiftBalance } from '@/mixins/utils'

  // Vuex
  import { mapState, mapActions } from 'vuex'

  import userProfileBroken from '@/assets/images/user-profile-broken.png'
  import groupplaceholder from '@/assets/images/groupplaceholder.png'

  import { isValidDuty, apiGetScaleDutiesRef, apiGetUserShiftsBetweenTwoDatesRef, getShiftPause } from '@/services/duties'
  import { rgxFirebaseKey, apiRefOpen, apiRefClose, getUserByUserID } from '@/services/firebase'
  import { durationHoursToMinutes, buildStartAtISO } from '@/functions/workingHours'

  // Mixins
  import stringMixin from '@/mixins/string.mixin.js'

  // User Interface useful components
  import SosSelect from '@/components/SosSelect'
  import SosButton from '@/components/SosButton'

  // ?
  import SosCurrentPlanBadge from '@/components/SosCurrentPlanBadge'

  // Modals
  import DetalhesDoPlantao from '@/modals/DetalhesDoPlantao'
  import NewUserDutyModal from './NewUserDutyModal'
  import ManagerUserModal from '@/modals/ManagerUserModal'
  import PassShiftsModal from './PassShiftsModal'

  // Moment JS
  import moment from 'moment'
  import 'moment/locale/pt-br'
  // moment.locale('pt-BR')

  //
  //
  //

  const selectMonths = { 1: 'Janeiro', 2: 'Fevereiro', 3: 'Março', 4: 'Abril', 5: 'Maio', 6: 'Junho', 7: 'Julho', 8: 'Agosto', 9: 'Setembro', 10: 'Outubro', 11: 'Novembro', 12: 'Dezembro' }

  export default {
    name: 'GroupUserShifts',

    components: {
      'manager-user-modal': ManagerUserModal,
      'new-user-duty-modal': NewUserDutyModal,
      'sos-select': SosSelect,
      'sos-button': SosButton,
      'detalhes-do-plantao': DetalhesDoPlantao,
      'sos-current-plan-badge': SosCurrentPlanBadge,
      'pass-shifts-modal': PassShiftsModal,
    },

    mixins: [
      stringMixin,
    ],

    data () {
      return {
        groupplaceholder,

        freeVersion,
        whiteLabel,

        loadingDuties: true,

        dutiesRef: null,
        loadedDuties: [],

        scaleID: 'all',
        scaleName: 'Todas as escalas',

        currentYear: '',
        currentMonth: '',
        currentMonthName: '',

        selectMonths: [
          { key: 'month_01', text: 'Janeiro', value: '01' },
          { key: 'month_02', text: 'Fevereiro', value: '02' },
          { key: 'month_03', text: 'Março', value: '03' },
          { key: 'month_04', text: 'Abril', value: '04' },
          { key: 'month_05', text: 'Maio', value: '05' },
          { key: 'month_06', text: 'Junho', value: '06' },
          { key: 'month_07', text: 'Julho', value: '07' },
          { key: 'month_08', text: 'Agosto', value: '08' },
          { key: 'month_09', text: 'Setembro', value: '09' },
          { key: 'month_10', text: 'Outubro', value: '10' },
          { key: 'month_11', text: 'Novembro', value: '11' },
          { key: 'month_12', text: 'Dezembro', value: '12' },
        ],

        userLocalProfile: {
          userID: null,
          isMe: null,
          userImage: null,
          userImageIsValid: null,
          userName: null,
          userEmail: null,
          userPhone: null,
          userCpf: null,
          userCnpj: null,
          userCrm: null,
          userPaymentProfile: null,
          hourlyRate: 'R$ 0,00',
          nickname: '',
          rawHourlyRate: 0,
        },

        loadingUserProfile: true,
      }
    },

    computed: {
      ...mapState({
        userSession: state => state.app.userSession,
        group: state => state.app.group,
        currentGroupCapabilities: state => state.app.currentGroupCapabilities,
        groupUsers: state => state.app.groupUsers,
        groupScales: state => state.app.groupScales,
        listeners: state => state.app.listeners,
        plans: state => state.app.plans,
      }),

      totalPeriodBalance () {
      if (!this.loadedDuties || this.loadedDuties.length === 0) {
        return '+00:00'
      }

      let totalMinutes = 0

      this.loadedDuties.forEach(item => {

        const balance = getShiftBalance(
          item.duty,
          item.dutyStartDateTZ === '+0000',
          item.dutyDate,
          item.dutyTime,
          item.dutyDuration
        )

        totalMinutes += balance
      })

      return this.formatMinutesToBalance(totalMinutes)
    },


      selectYears () {
        const getCurrentYear = moment().get('year')

        const previousYear = String(getCurrentYear - 1)
        const currentYear = String(getCurrentYear)
        const nextYear = String(getCurrentYear + 1)

        return [
          {
            key: `year_${previousYear}`,
            value: previousYear,
            text: previousYear,
          },
          {
            key: `year_${currentYear}`,
            value: currentYear,
            text: currentYear,
          },
          {
            key: `year_${nextYear}`,
            value: nextYear,
            text: nextYear,
          },
        ]
      },

      processedGroupScales () {
        return !!this.groupScales === true && Array.isArray(this.groupScales) && this.groupScales.length > 0 ? this.groupScales : []
      },

      selectScales ()
      {
        if (this.processedGroupScales.length === 0) return []

        const userID = this.$route.params.userID

        // ESCALAS DE CADA USUÁRIO DO GRUPO
        const userScales = this.processedGroupScales.filter(gs => gs.scaleRelatedUsers.some(relatedUserID => relatedUserID === userID)).map(gs => gs.scaleID)

        return [
          {
            key: 'all',
            value: 'all',
            formattedText: '<i aria-hidden="true" class="mdi mdi-calendar-multiple userShiftsScaleItemIcon"></i><span class="userShiftsScaleItemText">&nbsp;&nbsp;Todas as escalas</span>',
            text: 'Todas as escalas',
          },
          ...this.processedGroupScales.filter(s => (
            // Usuário relacionado a todas as escalas (Nota: Segundo a regra de negócio = Nenhuma escala relacionada)
            userScales.length === 0 ||
            (
              // Usuário encontrado + Relacionado a escala do plantão a ser dividido
              userScales.length > 0 &&
              userScales.some(scaleID => scaleID === s.scaleID)
            )
          )).map(scale => ({
            key: 'scale_' + scale.scaleID,
            value: scale.scaleID,
            text: scale.scaleName,
          })),
        ]
      },

      //
      // PERMISSIONS
      //

      permissaoDetalhesPlantaoNovoPlantao () {
        return this.currentGroupCapabilities ? this.currentGroupCapabilities[DETALHES_PLANTAO_NOVO_PLANTAO] : false
      },

      permissaoDetalhesPlantaoVer () {
        return this.currentGroupCapabilities ? this.currentGroupCapabilities[DETALHES_PLANTAO_VER] : false
      },
    },

    watch: {
      selectScales: {
        immediate: true,
        handler (defaultNew, defaultOld)
        {
          const oldOptions = typeof defaultOld === 'object' && Array.isArray(defaultOld) ? defaultOld : []
          const newOptions = typeof defaultNew === 'object' && Array.isArray(defaultNew) ? defaultNew : []

          // console.log('::: PLANTÕES DO USUÁRIO -> [selectScales] UPDATED:', oldOptions, newOptions)

          //
          // PRÉ-SELECIONA A PRIMEIRA ESCALA, DEPOIS QUE O AS ESCALAS DO GRUPO FORAM COLOCADAS NO VUEX
          //

          if (oldOptions.length === 0)
          {
            if (newOptions.length > 0 && this.dutiesRef === null)
            {
              //
              //
              //
              // SENHOR JESUS
              //
              // testar
              //
              //
              //

              // const scaleID = this.$store.state.app.listeners.groupScales[0].scaleID
              // const scaleName = this.$store.state.app.listeners.groupScales[0].scaleName

              const scaleID = newOptions[0].value
              const scaleName = newOptions[0].value === 'all' ? 'Todas as escalas' : newOptions[0].text

              this.scaleID = scaleID
              this.scaleName = scaleName

              // console.log('::: PLANTÕES DO USUÁRIO -> [selectScales] SYSTEM SELECTED "' + scaleName + '" SCALE. (ID: ' + scaleID + ')')

              // this.startDuties(scaleID, scaleName)
            }
            else if (this.listeners.loadingGroupScales === 'no' && this.processedGroupScales.length === 0)
            {
              this.loadingDuties = false

              // console.log('::: PLANTÕES DO USUÁRIO -> [selectScales] SYSTEM CAN\'T SELECT SCALE: This group doesn\'t have any scale.')
            }
          }
        },
      },
    },

    // created () {
      // console.log('::: PLANTÕES DO USUÁRIO -> created')
      // console.log('::: PLANTÕES DO USUÁRIO -> created [VUEX]:', this.listeners.groupScales)
    // },

    mounted ()
    {
      // Initialize MomentJS
      moment.locale('pt-BR')

      // Set current year and month
      const now = moment()
      const currentMonth = parseInt(now.format('MM'))

      this.currentYear = String(now.format('YYYY'))
      this.currentMonth = String(now.format('MM'))
      this.currentMonthName = selectMonths[currentMonth]

      // Loads group data if the user has not gone through the GROUP screen
      this.$store.dispatch('loadGroupPage', this.$route.params.groupID)

      // Load user
      this.loadUser()
    },

    // https://stackoverflow.com/questions/10246215/how-to-destroy-a-javascript-object
    // https://www.digitalocean.com/community/tutorials/vuejs-component-lifecycle-pt

    updated ()
    {
      // CARREGA PLANTÕES DA ESCALA

      if (
        this.dutiesRef === null &&
        this.currentYear !== '' &&
        this.currentMonth !== '' &&
        this.scaleID !== '' &&
        this.scaleName !== ''
      ) {
        // console.log('::: PLANTÕES DO USUÁRIO -> [updated] LOADING "' + this.scaleName + '" SCALE DUTIES...')

        this.startDuties(this.scaleID, this.scaleName, this.currentMonth, this.currentYear)
      }
    },

    beforeDestroy ()
    {
      this.stopDuties()
      this.clearComponent()
    },

    // unmounted () { },

    methods: {
      ...mapActions([
        'loadGroupUsersAll'
      ]),

      formatMinutesToBalance (totalMinutes) {
      const sign = totalMinutes >= 0 ? '+' : '-'
      const absMinutes = Math.abs(totalMinutes)
      const hours = Math.floor(absMinutes / 60)
      const mins = absMinutes % 60

      const h = String(hours).padStart(2, '0')
      const m = String(mins).padStart(2, '0')

      return `${sign}${h}:${m}`
    },
      /**
       *
       * MAINTENANCE
       *
       */

      async openPassShiftsModal() {
        this.loadingDuties = true;

        try {
          //TODO: ALTERAR PARA CARREGAMENTO PARCIAL DE USUÁRIOS, SE NECESSÁRIO
          await this.loadGroupUsersAll(this.group.groupID);

          if (this.$refs.passShiftsModal) {
            this.$refs.passShiftsModal.open(
              this.userLocalProfile.userID,
              this.userLocalProfile.userName,
              this.currentMonth,
              this.currentYear,
            );
          }

        } catch (error) {
          console.error("Erro ao carregar lista completa de usuários:", error);
        } finally {
          this.loadingDuties = false;
        }
      },

      clearComponent () {
        this.groupplaceholder = null
        delete this.groupplaceholder

        this.loadingDuties = true
        delete this.loadingDuties

        this.dutiesRef = null
        delete this.dutiesRef
        this.loadedDuties = []
        delete this.loadedDuties

        this.scaleID = ''
        delete this.scaleID
        this.scaleName = ''
        delete this.scaleName
        this.currentYear = ''
        delete this.currentYear
        this.currentMonth = ''
        delete this.currentMonth
        this.currentMonthName = ''
        delete this.currentMonthName

        this.selectMonths = []
        delete this.selectMonths

        // CLEANING
        this.userLocalProfile.userID = null
        this.userLocalProfile.isMe = null
        this.userLocalProfile.userImage = null
        this.userLocalProfile.userImageIsValid = null
        this.userLocalProfile.userName = null
        this.userLocalProfile.userEmail = null
        this.userLocalProfile.userPhone = null
        this.userLocalProfile.userCpf = null
        this.userLocalProfile.userCnpj = null
        this.userLocalProfile.userCrm = null
        this.userLocalProfile.userPaymentProfile = null
        this.userLocalProfile.hourlyRate = 'R$ 0,00'
        this.userLocalProfile.nickname = ''
        this.userLocalProfile.rawHourlyRate = 0
        this.userLocalProfile = {}
        delete this.userLocalProfile

        this.loadingUserProfile = false
        delete this.loadingUserProfile
      },

      /**
       *
       * DUTIES
       * - LOAD, PROCESS AND UNLOAD
       *
       */

      startDuties (scaleID, scaleName, month, year)
      {
        if (this.dutiesRef !== null) {
          // console.log(`::: PLANTÕES DO USUÁRIO -> CAN'T LOAD SHIFTS FROM "${scaleName}": Already initialized`)
          return false
        }

        // console.log('::: PLANTÕES DO USUÁRIO -> LOADING SHIFTS FROM "' + scaleName + '"...')

        this.loadingDuties = true
        this.loadedDuties = []

        const selectedYear = Number(year)
        const selectedMonth = Number(month) - 1
        const firstDate = moment.utc([selectedYear, selectedMonth, 1, 0, 0, 0, 0]).startOf('day')
        const lastDate = moment.utc([selectedYear, selectedMonth, 1, 0, 0, 0, 0]).endOf('month')

        // console.log('::: START DUTIES -> DATE RANGE:', firstDate.format('YYYY-MM-DD HH:mm:ss'), lastDate.format('YYYY-MM-DD HH:mm:ss'))
        // console.log('::: START DUTIES -> userID:', this.$route.params.userID)

        this.dutiesRef = scaleID === 'all' ? (
          apiGetUserShiftsBetweenTwoDatesRef(this.$route.params.userID, firstDate, lastDate)
        ) : (
          apiGetScaleDutiesRef(scaleID, { type: 'userduties', month, year })
        )

        // console.log('::: dutiesRef:', this.dutiesRef)

        apiRefOpen(this.dutiesRef, this.onDutiesUpdate)
      },

      stopDuties () {
        if (this.dutiesRef !== null) {
          apiRefClose(this.dutiesRef, this.onDutiesUpdate)

          this.loadingDuties = false /* Senhor Jesus */
          this.loadedDuties = []

          this.dutiesRef = null

          // console.log('::: PLANTÕES DO USUÁRIO -> STOPPED DUTIES.')
        }
      },

      async onDutiesUpdate (dutiesResponse) {
        const fbDuties = (dutiesResponse && dutiesResponse.val()) ? dutiesResponse.val() : false
        const duties = (fbDuties && typeof fbDuties === 'object') ? fbDuties : false
        const dutiesKeys = duties !== false ? Object.keys(fbDuties) : []

        /* if (this.loadingDuties === true) {
          this.loadingDuties = false
        } */

        if (dutiesKeys.length === 0)
        {
          this.loadedDuties = []
          this.loadingDuties = false
        }
        else
        {
          const plantoes = dutiesKeys.map(dutyID => {
            const duty = fbDuties[dutyID]

            if (!isValidDuty(duty)) {
              // console.log('::: PLANTÕES DO USUÁRIO -> DUTIES[invalid]:', dutyID, duty)
              return false
            }

            if (duty.uid_pegou !== this.$route.params.userID) {
              return false
            }

            if (duty.groupID !== this.$route.params.groupID) {
              return false
            }

            //
            // O plantonista está passando o plantão para outro usuário?
            //

            const isExpiredForReiciving = isShiftExpired(duty.data_inicio, duty.hora_inicio, duty) // TESTAR VENCIMENTO

            const isPassing = !!duty.uid_pegando && rgxFirebaseKey.test(duty.uid_pegando) && !isExpiredForReiciving

            //
            // ?
            //

            const dutyIsCancelled = duty.status === 'cancelado'

            const tz = duty.dutyStartDateTZ || ''
            const dutyStartDate = (tz === '+0000' ? moment.utc(duty.data_inicio) : moment(duty.data_inicio))

            const dutyWeekDay = dutyStartDate.day()
            const dutyDay = dutyStartDate.format('DD')
            const dutyDateFilter = dutyStartDate.format('YYYY/MM')

            let dutyWeekDayName = ''
            if (dutyWeekDay === 0) {
              dutyWeekDayName = 'DOM'
            } else if (dutyWeekDay === 1) {
              dutyWeekDayName = 'SEG'
            } else if (dutyWeekDay === 2) {
              dutyWeekDayName = 'TER'
            } else if (dutyWeekDay === 3) {
              dutyWeekDayName = 'QUA'
            } else if (dutyWeekDay === 4) {
              dutyWeekDayName = 'QUI'
            } else if (dutyWeekDay === 5) {
              dutyWeekDayName = 'SEX'
            } else if (dutyWeekDay === 6) {
              dutyWeekDayName = 'SAB'
            }

            //
            // PAUSA
            //

            duty.lastShiftBreak = getShiftPause(duty)

            //
            //
            //

            return {
              plantaoID: dutyID,
              isPassing,
              dutyIsCancelled,
              dutyDate: duty.data_inicio,
              dutyTime: duty.hora_inicio,
              sortDuration: durationToMinutes(formatDbTime(duty.periodo)),
              dutyWeekDayName,
              dutyDay,
              dutyValue: formatMoney(duty.valor || 0),
              dutyDuration: formatFloatToScaleDuration(duty.periodo),
              dutyDateFilter,
              dutyStartDateTZ: tz,
              duty: {
                plantaoID: dutyID,
                ...duty,
                _violations: [],
              },
            }
          }).filter(duty => !!duty === true)

          /*  */

          // const order = 'ASC'

          // necessário? firebase já retorna com sort?

          // ORDEM CRESCENTE (a - b) - ORDEM DECRESCENTE (b - a)

          plantoes.sort((a, b) => {
            const tza = a.dutyStartDateTZ || ''
            const tzb = b.dutyStartDateTZ || ''

            const aDataInicio = (tza === '+0000' ? moment.utc(a.dutyDate) : moment(a.dutyDate)).format('YYYY-MM-DD')
            const bDataInicio = (tzb === '+0000' ? moment.utc(b.dutyDate) : moment(b.dutyDate)).format('YYYY-MM-DD')

            const ad = moment(`${aDataInicio} ${a.dutyTime}:00`, 'YYYY-MM-DD HH:mm:ss').unix()
            const bd = moment(`${bDataInicio} ${b.dutyTime}:00`, 'YYYY-MM-DD HH:mm:ss').unix()

            // return order === 'ASC' ? (ad - bd) : (bd - ad)

            // Secondary sort by duration
            if (`${aDataInicio} ${a.dutyTime}` === `${bDataInicio} ${b.dutyTime}`) return a.sortDuration - b.sortDuration

            // Primary sort by start time
            return ad - bd
          })

          // console.log('::: PLANTÕES DO USUÁRIO -> LOADED "' + dutiesKeys.length + '" SCALE DUTIES and "' + plantoes.length + '" USER DUTIES.')

          this.loadedDuties = plantoes
          this.loadingDuties = false

          this.validateLoadedDutiesRules(plantoes)
        }
      },

      // Valida em lote os plantões carregados do usuário contra as regras de carga
      // horária e anexa as violações a cada card (exibidas no card e no modal de
      // detalhes). Cada plantão é validado como item; ignore_duty_ids evita contá-lo
      // contra si mesmo no conjunto existente (senão geraria falso descanso/dobra).
      async validateLoadedDutiesRules (plantoes) {
        try {
          if (!plantoes || plantoes.length === 0) return

          const groupId = this.$route.params.groupID
          const dutyIds = plantoes.map(p => p.plantaoID)
          const items = plantoes
            .filter(p => p.duty && p.duty.uid_pegou && p.duty.scaleID && p.duty.data_inicio && p.duty.hora_inicio)
            .map(p => ({
              candidate_id: p.plantaoID,
              duty_id: p.plantaoID,
              user_id: p.duty.uid_pegou,
              scale_id: p.duty.scaleID,
              status: p.duty.status,
              start_at: buildStartAtISO(moment(p.duty.data_inicio).format('YYYY-MM-DD'), p.duty.hora_inicio),
              duration_minutes: durationHoursToMinutes(p.duty.periodo),
            }))

          if (items.length === 0) return

          const result = await this.$store.dispatch('VALIDATE_RULES_BATCH', {
            groupId,
            items,
            operation: 'batch',
            options: { ignore_duty_ids: dutyIds },
          })

          const data = result && result.data ? result.data : result
          const violations = (data && data.violations) || []

          // Evita corrida com o listener em tempo real: só aplica se a lista não mudou
          if (this.loadedDuties !== plantoes) return

          const byDuty = {}
          violations.forEach(v => {
            const id = v.duty_id || v.candidate_id
            if (!id) return
            if (!byDuty[id]) byDuty[id] = []
            byDuty[id].push(v)
          })

          plantoes.forEach(p => {
            p.duty._violations = byDuty[p.plantaoID] || []
          })
        } catch (e) {
          // Exibição é best-effort: falha de validação não quebra a listagem
        }
      },

      /**
       *
       * MAINTENANCE
       *
       */

      onUserUpdate ()
      {
        this.loadUser()
      },

      openEditUserProfile ()
      {
        //
        //
        //

        /* if (freeVersion === false && this.userSession.userCapabilities.editorUsuarios !== true)
        {
          const planName = this.userSession.planName.name

          const talkToOurSupport = `<a href="https://api.whatsapp.com/send?phone=5513992061010&text=Olá, estou no ${planName} e não consigo editar usuários. Preciso de ajuda." target="_blank">suporte</a>`
          const textSupport = `<p>Por favor, verifique a situação do seu plano com o nosso ${talkToOurSupport}.</p>`

          if (this.userSession.planOrigin === 'CUSTOM') {
            // Plano personalizado
            this.openSubscriptionModal('Verifique seu plano', `<p>Você está no ${planName} personalizado, mas a gestão de usuários não está liberada.</p>${textSupport}`)
          } else if (this.userSession.planOrigin === 'COUPON') {
            // Cupom ativo
            this.openSubscriptionModal('Verifique seu plano', `<p>Você tem um cupom ativo e está no ${planName}, mas a gestão de usuários não está liberada.</p>${textSupport}`)
          } else if (this.userSession.planOrigin === 'VINDI' && this.userSession.vindi.paymentStatus === 'paid') {
            // Assinatura ativa na vindi
            this.openSubscriptionModal('Faça um upgrade', `<p>Você está no ${planName}.</p><p>Para editar o usuário, assine o Plano Bronze ou superior.</p><p>Para mais informações, converse o nosso ${talkToOurSupport}.</p>`)
          } else if (this.userSession.planOrigin === 'VINDI' && this.userSession.vindi.paymentStatus !== 'paid') {
            // Assinatura ativa, mas com alguma pendência ou erro na vindi
            this.openSubscriptionModal('Verifique sua assinatura', `<p>Você é assinante do ${planName}, mas ele não está ativo e a gestão de usuários não está liberada.</p>${textSupport}`)
          } else {
            if (!!this.userSession.vindi === true) {
              // Plano da vindi expirado
              this.openSubscriptionModal('Verifique sua assinatura', `<p>Você assinou o ${this.userSession.vindi.planName.name}, mas ele expirou.</p><p>Agora você está no ${planName} e a gestão de usuários não está liberada.</p>${textSupport}`)
            } else {
              // Plano gratuíto ou alcançou alguma condição desconhecida
              this.openSubscriptionModal('Verifique seu plano', `<p>Você está no ${planName} e a gestão de usuários não está liberada.</p>${textSupport}`)
            }
          }

          return false
        } */

        //
        //
        //

        this.$refs.userModal.open(this.$route.params.userID, this.$route.params.groupID)
      },

      async loadUser ()
      {
        this.loadingUserProfile = true

        const perfil = await getUserByUserID(this.$route.params.userID)

        if (!!perfil === true)
        {
          // NOME
          const nomeCompleto = !!perfil.nome === true ? String(perfil.nome).trim() : ''

          // IMAGEM
          const isValidImage = !!perfil.img === true && typeof perfil.img === 'string' && perfil.img.indexOf('https://') !== -1

          // TELEFONE
          const ddd = !!perfil.ddd === true ? String(perfil.ddd).trim() : ''
          const phone = !!perfil.tel === true ? String(perfil.tel).trim() : ''
          const telefone = ddd.length === 2 && (phone.length === 8 || phone.length === 9) ? ('(' + ddd + ') ' + (phone.length === 8 ? phone.replace(/(\d{4})(\d{4})/, '$1-$2') : phone.replace(/(\d{5})(\d{4})/, '$1-$2'))) : ''

          // CPF
          const cpf = processUserCpf(perfil)
          const maskedCPF = cpf.length === 11 ? cpf.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})*/, '$1.$2.$3-$4') : ''

          // CNPJ
          const cnpj = processUserCnpj(perfil)
          const maskedCNPJ = cnpj.length === 14 ? cnpj.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, '$1.$2.$3/$4-$5') : ''

          // ME
          const currentID = !!this.userSession === true && !!this.userSession.uid === true ? this.userSession.uid : false

          // USER
          const userGroup = !!perfil.grupos === true && !!perfil.grupos[this.$route.params.groupID] === true ? perfil.grupos[this.$route.params.groupID] : null
          const rawHourlyRate = !!userGroup === true && !!userGroup.hourlyrate === true ? userGroup.hourlyrate : 0
          const nickname = !!userGroup === true && !!userGroup.nickname === true ? String(userGroup.nickname).trim() : ''

          const userLocalProfile = {
            userID: this.$route.params.userID,
            isMe: this.$route.params.userID === currentID,
            userImage: isValidImage ? perfil.img : userProfileBroken,
            userImageIsValid: isValidImage,
            // userName: nomeCompleto ? nomeCompleto.split(' ')[0] : '',
            userName: !!nomeCompleto === true ? nomeCompleto : '',
            userEmail: !!perfil.email === true ? perfil.email.trim() : '',
            userPhone: telefone,
            userCpf: maskedCPF,
            userCnpj: maskedCNPJ,
            userCrm: !!perfil.crm === true ? perfil.crm.trim() : '',
            userPaymentProfile: !!perfil.conta === true ? perfil.conta.trim() : '',
            hourlyRate: rawHourlyRate > 0 ? formatMoney(rawHourlyRate) : 'R$ 0,00',
            nickname,
            rawHourlyRate,
          }

          this.userLocalProfile = userLocalProfile

          // console.log('::: PLANTÕES DO USUÁRIO -> LOADED USER PROFILE:', userLocalProfile)
        }

        this.loadingUserProfile = false
      },

      /**
       *
       * SCALE, MONTH AND YEAR SELECTS EVENTS
       *
       */

      onSelectScale (scaleID, scaleName)
      {
        this.scaleID = scaleID
        this.scaleName = scaleName

        this.stopDuties()
        this.startDuties(scaleID, scaleName, this.currentMonth, this.currentYear)
      },

      selectedMonth (month)
      {
        const monthInteger = parseInt(month)

        this.currentMonthName = selectMonths[monthInteger]
        this.currentMonth = month

        this.stopDuties()
        this.startDuties(this.scaleID, this.scaleName, month, this.currentYear)
      },

      selectedYear (year)
      {
        this.currentYear = year

        this.stopDuties()
        this.startDuties(this.scaleID, this.scaleName, this.currentMonth, year)
      },

      /**
       *
       * NAVIGATION
       *
       */

      // OPEN "NOVO PLANTÃO" WINDOW/POPUP/MODAL
      openNewUserDutyModal: function ()
      {
        this.$refs.newUserDutyModal.open(this.currentYear, this.currentMonth, this.userLocalProfile.rawHourlyRate)
      },

      // OPEN "VIEW DUTY" WINDOW/POPUP/MODAL
      async openDuty (shift)
      {
        if (!!this.permissaoDetalhesPlantaoVer === false) return false
        this.loadingDuties = true
        try {
          await this.loadGroupUsersAll(this.group.groupID)
          const selectedYear = Number(this.currentYear)
          const selectedMonth = Number(this.currentMonth) - 1

          const firstDate = moment.utc([selectedYear, selectedMonth, 1, 0, 0, 0, 0]).startOf('day')
          const lastDate = moment.utc([selectedYear, selectedMonth, 1, 0, 0, 0, 0]).endOf('month')

          // console.log('::: USER SHIFTS - selectedYear, selectedMonth:', selectedYear, selectedMonth)
          // console.log('::: USER SHIFTS - firstDate:', firstDate.format('YYYY-MM-DD HH:mm:ss'))
          // console.log('::: USER SHIFTS - lastDate:', lastDate.format('YYYY-MM-DD HH:mm:ss'))

          this.$refs.dutyModal.open(shift.plantaoID || '', firstDate, lastDate, shift._violations || [])
        } catch (error) {
          console.error("Erro ao carregar lista completa de usuários:", error);
        } finally {
          this.loadingDuties = false
        }

        // console.log('::: PLANTÕES POR USUÁRIO[openDuty]:', shift)


      },

      // BACK TO THE "GROUP DETAILS" SCREEN
      goBackToGroupScales () {
        this.$router.push(`/admin/grupos/${this.$route.params.groupID}/escalas?tab=usuarios`)
      },

      // GO TO THE "SUBSCRIPTION" SCREEN
      navigateToPlans () {
        this.$router.push('/admin/assinatura')
      },
    },
  }

</script>

<style lang="sass">

  .userShiftsScaleItemText
    display: inline-block
    vertical-align: middle
    color: #00008b

  .userShiftsScaleItemIcon
    display: inline-block
    vertical-align: middle
    color: #00008b
    font-size: 20px
    line-height: 0

</style>

<style lang="sass" scoped>

  .sosField
    position: relative

    margin-top: 15px
    margin-bottom: 15px

    &.sosField--first
      margin-top: 0

    &.sosField--last
      margin-bottom: 0

  .sosFieldGroup
    position: relative

    // margin-top: 15px
    // margin-bottom: 15px
    margin-top: 10px
    margin-bottom: 10px
    margin-left: -5px
    margin-right: -5px

    .sosField
      display: inline-block
      vertical-align: middle
      padding: 5px
      margin-top: 0
      margin-bottom: 0

      &.sosFieldColumn--1,
      &.sosFieldColumn--2
        width: 50%

  //

  .loaderGestor
    display: block
    height: 20px
    width: 20px
    -webkit-animation: loaderGestor 800ms linear infinite
    animation: loaderGestor 800ms linear infinite

  @-webkit-keyframes loaderGestor
    0%
      -webkit-transform: rotate(0deg)
    100%
      -webkit-transform: rotate(360deg)

  @keyframes loaderGestor
    0%
      transform: rotate(0deg)
    100%
      transform: rotate(360deg)

  .loaderGestor span
    display: block
    position: absolute
    top: 0
    left: 0
    bottom: 0
    right: 0
    margin: auto
    height: 20px
    width: 20px
    clip: rect(10px, 20px, 20px, 0)
    -webkit-animation: loaderGestor-2 400ms cubic-bezier(0.770, 0.000, 0.175, 1.000) infinite
    animation: loaderGestor-2 400ms cubic-bezier(0.770, 0.000, 0.175, 1.000) infinite

  @-webkit-keyframes loaderGestor-2
    0%
      -webkit-transform: rotate(0deg)
    100%
      -webkit-transform: rotate(360deg)

  @keyframes loaderGestor-2
    0%
      transform: rotate(0deg)
    100%
      transform: rotate(360deg)

  .loaderGestor span::before
    content: ""
    display: block
    position: absolute
    top: 0
    left: 0
    bottom: 0
    right: 0
    margin: auto
    height: 20px
    width: 20px
    border: 1px solid transparent
    border-top: 1px solid #000000
    border-radius: 50%
    -webkit-animation: loaderGestor-3 400ms cubic-bezier(0.770, 0.000, 0.175, 1.000) infinite
    animation: loaderGestor-3 400ms cubic-bezier(0.770, 0.000, 0.175, 1.000) infinite

  @-webkit-keyframes loaderGestor-3
    0%
      -webkit-transform: rotate(0deg)
    100%
      -webkit-transform: rotate(360deg)

  @keyframes loaderGestor-3
    0%
      transform: rotate(0deg)
    100%
      transform: rotate(360deg)

  .loaderGestor span::after
    content: ""
    display: block
    position: absolute
    top: 0
    left: 0
    bottom: 0
    right: 0
    margin: auto
    height: 20px
    width: 20px
    border: 1px solid rgba(0, 0, 0, 0.5)
    border-radius: 50%

  .btn
    position: relative

  @media (max-width: 1280px)
    .groupUserDuties
      overflow-x: auto

  @media (max-width: 768px)
    .groupUserDuties
      overflow-x: visible

</style>

<style scoped lang="scss">

  .pageBody {
    margin-top: 20px;
    // padding: 20px 30px;
    padding: 30px;
    border-radius: 5px;
    // border-top-left-radius: 5px;
    // border-top-right-radius: 5px;
    background-color: white;
    box-shadow: 0px 3px 7px -5px rgba(0, 0, 0, 0.5);
  }

  .pageGroupContainer {
    max-width: 1200px;
    margin-left: auto;
    margin-right: auto;
  }

  .userProfileItem
  {
    font-size: 15px;
    line-height: 30px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;

    > b {
      white-space: nowrap;
    }

    > span {
      word-break: break-word;
    }
  }

  .groupTitleImage,
  .groupTitleText {
    display: inline-block;
    vertical-align: top;
  }

  .groupTitleImage {
    // width: 25%;
    // max-width: 80px;
    width: 30%;
    // height: 80px;
    max-width: 90px;

    .groupImage {
      display: inline-block;
      // width: 80px;
      // height: 80px;
      width: 90px;
      height: 90px;
      overflow: hidden;
      border-radius: 7px;
      border: 1px solid rgba(0, 0, 0, 0.1);
      box-shadow: 2px 2px 4px 0px rgba(0, 0, 0, 0.1);

      .groupUserImage {
        display: inline-block;
        width: 100%;
        // max-width: 80px;
        // height: 80px;
        max-width: 90px;
        height: 90px;
        background-repeat: no-repeat;
        background-size: cover;
        background-color: rgba(0, 0, 0, 0.5);
      }
    }
  }

  .groupTitleText {
    // width: 75%;
    width: 70%;
    padding-left: 20px;
  }

  .groupUserDutiesHeader {
    margin-top: 30px;
    padding: 10px 30px;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    background-color: dodgerblue;

    color: #FFFFFF;
    font-size: 18px;
    font-weight: 600;
  }

  .headerContent {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
  }

  .periodBalance {
    font-size: 16px;
    background-color: rgba(255, 255, 255, 0.2);
    padding: 4px 12px;
    border-radius: 20px;
    white-space: nowrap;

    .balanceLabel {
      font-weight: 400;
      font-size: 14px;
      opacity: 0.9;
    }

    .balanceValue {
      font-weight: 700;
      font-size: 17px;
    }
  }
  .periodBalance.negative-balance .balanceValue {
    color: #ffcccc;
  }
  .periodBalance.positive-balance .balanceValue {
    color: #ccffcc;
  }

  /* .groupUserDuties--loadingWrapper {
    transition-property: opacity, visibility;
    transition-duration: 200ms;

    opacity: 0;
    visibility: hidden;

    z-index: 1;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    background-color: rgba(0, 0, 0, 0.5);

    span {
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;

      display: inline-block;
      height: 25px;
      margin: auto;

      color: #FFFFFF;
      font-weight: 500;
      text-align: center;
      line-height: 25px;
    }
  } */

  .groupUserDutiesMonthWrapper {
    transition-property: opacity;
    transition-duration: 200ms;
  }

  .groupUserDuties {
    position: relative;
    padding: 27px;
    // padding: 30px; // retirar
    border-left: 1px solid rgba(30, 144, 255, 0.5);
    border-right: 1px solid rgba(30, 144, 255, 0.5);
    border-bottom: 1px solid rgba(30, 144, 255, 0.5);
    border-bottom-right-radius: 10px;
    border-bottom-left-radius: 10px;

    &.groupUserDuties--loading {
      /* .groupUserDuties--loadingWrapper {
        opacity: 1;
        visibility: visible;
      } */

      .groupUserDutiesMonthWrapper {
        opacity: 0.2;
      }
    }
  }

  /* .groupUserDutiesColumn--1,
  .groupUserDutiesColumn--2 {
    display: inline-block;
    vertical-align: middle;
    padding: 30px;
  }

  .groupUserDutiesColumn--1 {
    width: 25%;
    border-right: 1px solid rgba(30, 144, 255, 0.5);
  }

  .groupUserDutiesColumn--2 {
    width: 75%;
  } */

  /* .groupUserDutiesMonth--duties {
    margin: -3px;
  } */

  .groupUserDutiesMonth--duty {
    user-select: none;

    position: relative;

    display: inline-block;
    vertical-align: middle;
    width: 111px;
    // width: 105px;
    // height: 112px;
    margin: 3px;
    border-radius: 10px;
    box-shadow: inset -1px -1px 1px rgba(0, 0, 0, 0.18);
    background-color: orange;
    // background-color: darkseagreen;

    // overflow: hidden; // Nota: NECESSÁRIO?

    color: #FFF;
    text-align: center;
    text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.2);
    line-height: 0;

    &.groupUserDutiesMonth--duty__started {
      // greenyellow lightseagreen
      background-color: greenyellow;
      color: #555555;
      text-shadow: none;

      .groupUserDutiesMonth--dutyWeekDay {
        font-weight: 500;
      }

      .groupUserDutiesMonth--dutyDay {
        font-weight: 400;
      }

      .groupUserDutiesMonth--dutyTime {
        font-weight: 500;
      }

      .groupUserDutiesMonth--dutyValue {
        font-weight: 500;
      }
    }

    &.groupUserDutiesMonth--duty__cancelled {
      background-color: orangered;
      color: #DDDDDD;
    }

    &.groupUserDutiesMonth--duty__finished {
      // background-color: teal;
      background-color: #502c2c;
      color: #DDDDDD;
      /* background-color: steelblue;
      color: #EEEEEE; */
    }

    .groupUserDutiesMonth--dutyBody {
      position: relative;
      padding: 8px 10px 0 10px;

      .dutyLabel {
        position: absolute;
        transform: rotate(-7deg);
        left: -7px;
        top: 52px;

        width: 120px;
        background-color: rgba(255, 255, 0, 0.8);

        color: #000000;
        font-size: 9px;
        line-height: 12px;
        font-weight: 500;
        letter-spacing: 1px;
        text-transform: uppercase;
      }
    }

    .groupUserDutiesMonth--dutyValue {
      margin-top: 5px;
      padding: 3px;
      border-radius: 0;
      background-color: rgba(0, 0, 0, 0.1);

      font-size: 11px;
      line-height: 11px;
      font-weight: 600;
    }
  }

  .dutyCard--passing {
    position: absolute;
    top: -5px;

    height: 15px;
    padding: 0px 5px;
    border-top-left-radius: 5px;
    border-bottom-right-radius: 5px;
    background-color: rgba(0, 100, 0, 0.8);

    font-size: 9px;
    line-height: 15px;
    font-weight: 600;
    text-shadow: none;
  }

  .dutyCard--violation {
    position: absolute;
    top: -7px;
    right: -7px;
    z-index: 2;

    width: 18px;
    height: 18px;
    border-radius: 50%;
    background-color: #f0ad4e;
    color: #ffffff;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.4);

    text-align: center;
    line-height: 18px;

    i {
      font-size: 13px;
      line-height: 18px;
    }

    &.dutyCard--violation__block {
      background-color: #d9534f;
    }
  }

  .groupUserDutiesMonth--dutyInner1 {
    display: inline-block;
    vertical-align: middle;
    width: 40%;
    text-align: center;
  }

  .groupUserDutiesMonth--dutyInner2 {
    display: inline-block;
    vertical-align: middle;
    width: 60%;
    padding-left: 7px;
    text-align: right;
  }

  .groupUserDutiesMonth--dutyWeekDay {
    margin-bottom: 3px;
    font-size: 12px;
    line-height: 12px;
    font-weight: 800;
    /* text-transform: uppercase; */
  }

  .groupUserDutiesMonth--dutyDay {
    font-size: 24px;
    line-height: 24px;
    font-weight: 500;
  }

  .groupUserDutiesMonth--dutyTime {
    margin-top: 3px;
    font-size: 11px;
    line-height: 12px;
    font-weight: 800;
    text-align: left;

    span {
      display: inline-block;
      width: 100%;
    }
  }

  .groupUserDutiesMonth--dutyScaleName {
    display: inline-block;
    width: 100%;
    margin-top: 7px;

    font-size: 11px;
    line-height: 11px;
    font-weight: 800;

    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  //

  p {
    margin: 0;
  }

  .info-card-item-upgrade-container {
    padding: 0 0 !important;
    display: flex;
    flex-direction: row;
    min-height: 80px;
    height: 100% !important;
    text-transform: none;
  }

  .btn-info-container {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }

  .plan-description {
    color: #000;
    font-weight: 400;
  }

  .plan-name {
    font-size: 19px;
    color: #000;
  }

  .upgrade-text {
    color: #FFF;
  }

  .upgrade-arrow-icon {
    width: 50px;
    height: 50px;
  }

  ul {
    list-style: none;
  }

  /*  */

  .column {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    @media (min-width: 767px) {
      justify-content: center;
    }
    &[start] {
      justify-content: flex-start;
    }
    &[end] {
      justify-content: flex-end;
    }
    &[space-between] {
      justify-content: space-between;
    }
  }

  .blockTitle {
    color: #305050;
    font-size: 25px;
    line-height: 25px;
    word-wrap: break-word;
  }

  .csCol {
    display: inline-block;
    vertical-align: top;

    &.csCol--1 {
      width: 40%;
    }

    &.csCol--2 {
      width: 40%;
    }

    &.csCol--3 {
      width: 20%;
    }
  }

  .csCol--3 {
    text-align: right;
  }

  @media (max-width: 1280px) {
    .csCol {
      &.csCol--1 {
        width: 50%;
      }

      &.csCol--2 {
        width: 50%;
      }

      &.csCol--3 {
        width: 100%;
        margin-top: 25px;

        text-align: center;
      }
    }
  }

  @media (max-width: 1164px) {
    .groupTitleImage {
      width: 30%;
    }

    .groupTitleText {
      width: 70%;
    }
  }

  @media (max-width: 960px) {
    .groupTitleArea {
      position: relative;
    }

    .groupTitleImage {
      position: absolute;
      left: 0;
      top: 0;

      width: 100%;
    }

    .groupTitleText {
      width: 100%;
      padding-left: 100px;
    }

    .csCol {
      &.csCol--1 {
        width: 100%;
      }

      &.csCol--2 {
        width: 100%;
        margin-top: 35px;
      }

      &.csCol--3 {
        width: 100%;
      }
    }
  }

  @media (max-width: 600px) {
    .btnVoltar {
      width: 100%;
    }
  }

</style>
